import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader'; // Adjust the import path as necessary
import PatientDetails from './PatientDetails';
import PatientExaminationAndEvaluation from './ExaminationAndEvalutation';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import TreatmentPlan from './TreatmentPlan';
import Fms from './fms/fms';
import PatientHistory from './PatientHistory';
import GeneralDetails from './GeneralDetails';
import {
  cancelCycleApi,
  createOrUpdateCycleApi,
  getPatientDetailsApi,
  updatePatientColumnApi,
  updatePatientExaminationDetailsApi,
  updatePatientHistoryDetailsApi,
  updatePatientInfertilityDetailsApi,
  updatePatientTreatmentPlanApi,
  getAllCyclesApi,
} from '../../../api/patientApi';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { OtherCycles } from './fms/OtherCycles';
import {
  resetPatientData,
  setPatientDataCurrentCycle,
  setSelectedPatientData,
} from '../../../actions';
import ProtectedComponent from '../../../common/ProtectedComponent';
import {
  permissionsList,
  permissionsWithAssignedIds,
} from '../../../api/constant';

const ClinicalProcess = () => {
  const { id: patientId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialTab = parseInt(queryParams.get('tab')) || 1;
  const cycleIdParam = queryParams.get('cycleId');
  const isReadOnlyParam = queryParams.get('readOnly') === 'true';

  const [activeTab, setActiveTab] = useState(initialTab);
  const [loading, isLoading] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(isReadOnlyParam);
  const [selectedCycleData, setSelectedCycleData] = useState(null);
  const [loadingCycleData, setLoadingCycleData] = useState(false);
  
  const patientData = useSelector((state) => state.clinicalReducer);
  const currentCycle = useSelector(
    (state) => state.clinicalReducer.currentCycle,
  );

  const previousCycle = useSelector((state) => state.clinicalReducer.oldCycle);
  const cycleId = patientData?.currentCycle?.cycleId;
  const dispatch = useDispatch();

  useEffect(() => {
    setActiveTab(initialTab);
    setIsReadOnly(isReadOnlyParam);
    
    // If we have a specific cycle ID from URL params, load that cycle data
    if (cycleIdParam && isReadOnlyParam) {
      loadCycleData(cycleIdParam);
    }
  }, [initialTab, isReadOnlyParam, cycleIdParam, patientData.selectedPatientData]);

  const loadCycleData = async (targetCycleId) => {
    try {
      setLoadingCycleData(true);
  
      
      if (patientData.selectedPatientData?.patient?.patientCycles) {

        
        
        let cycle = patientData.selectedPatientData.patient.patientCycles.find(
          c => {
            const match =  c.cycleId == targetCycleId;
            return match;
          }
        );
        
        if (cycle) {
          
          const formattedCycle = {
            ...cycle,
            fmsData: cycle.fmsData || {
              tableData: [],
              comments: '',
              treatmentPlanForm: {
                lmp: '',
                amh: '',
                diagnosis: '',
                plan: '',
                customTreatmentPlan: 'NC',
                customTreatmentPlanOther: '',
                treatmentPlanDate: ''
              }
            }
          };
          
          setSelectedCycleData(formattedCycle);
          dispatch(setPatientDataCurrentCycle(formattedCycle));
          setLoadingCycleData(false);
          return;
        } else {
          console.log('Cycle not found in loaded patient data');
        }
      } else {
        console.log('No patient cycles available in loaded data');
      }
      
      const allCycles = await getAllCyclesApi(patientId);
      
      const cycle = allCycles.find(c =>  c.cycleId == targetCycleId);
      if (cycle) {
        console.log('Found cycle from API:', cycle);
        
        const formattedCycle = {
          ...cycle,
          fmsData: cycle.fmsData || {
            tableData: [],
            comments: '',
            treatmentPlanForm: {
              lmp: '',
              amh: '',
              diagnosis: '',
              plan: '',
              customTreatmentPlan: 'NC',
              customTreatmentPlanOther: '',
              treatmentPlanDate: ''
            }
          }
        };
        
       
        setSelectedCycleData(formattedCycle);
        dispatch(setPatientDataCurrentCycle(formattedCycle));
      } else {
        console.log('Cycle not found in API response');
      }
      
      setLoadingCycleData(false);
    } catch (error) {
      console.error('Error loading cycle data:', error);
      toast.error('Error loading cycle data');
      setLoadingCycleData(false);
    }
  };

  const handleSubmit = async () => {
    if (isReadOnly) {
      toast.info('Cannot save in read-only mode');
      return;
    }

    await saveGeneralDetails();
    isLoading(true);

    if (activeTab == 1) {
      // TODO: remove priSec. added becuase required field in backend
      await updatePatientInfertilityDetailsApi(patientId, {
        ...patientData.infertilityDetails,
        updatedAt: null,
        createdAt: null,
        priSec: 'Primary',
      });
      toast.success('Patient Details Saved Successfully');
    }
    if (activeTab == 2) {
      await updatePatientHistoryDetailsApi(patientId, {
        ...patientData.patientHistory,
        updatedAt: null,
        createdAt: null,
      });
      toast.success('Patient History Saved Successfully');
    }
    if (activeTab == 3) {
      await examinationHandler();
      toast.success('Examination Saved Successfully');
    }
    if (activeTab == 4) {
      await updatePatientTreatmentPlanApi(patientId, {
        ...patientData.treatmentPlan,
        updatedAt: null,
        createdAt: null,
      });
      toast.success('Treatment Plan Saved Successfully');
    }

    if (activeTab == 5) {
      await createOrUpdateCycleApi(
        patientId,
        cycleId,
        patientData.currentCycle.fetSheet,
        patientData.currentCycle.fmsData,
        dispatch,
      );
      if (cycleId) {
        toast.success('Cycle Saved Successfully');
      } else {
        toast.success('New Created Successfully');
      }
    }
    isLoading(false);
  };

  const handleCycleCancel = async () => {
    if (isReadOnly) {
      toast.info('Cannot cancel cycle in read-only mode');
      return;
    }
    
    try {
      isLoading(true);
      await cancelCycleApi(cycleId);
      dispatch(setPatientDataCurrentCycle({ ...currentCycle, cycleId: null }));
      toast.success('Cycle Cancelled Successfully');
      isLoading(false);
    } catch (error) {
      console.error('Error cancelling cycle:', error);
      toast.error('Error cancelling cycle');
      isLoading(false);
      throw error;
    }
  };

  const examinationHandler = async () => {
    isLoading(true);
    const patientExaminationDetails = {
      examinationOfFemalePartner: patientData.examinationOfFemalePartner,
      investigationOfFemalePartner: patientData.investigationOfFemalePartner,
      evalutionOfMalePartner: patientData.evalutionOfMalePartner,
      examinationOfMalePartner: patientData.examinationOfMalePartner,
      updatedAt: new Date(),
    };
    try {
      const response = await updatePatientExaminationDetailsApi(
        patientId,
        patientExaminationDetails,
      );
      isLoading(false);
    } catch (error) {
      console.error('Error updating examination details:', error);
      toast.error('Error updating examination details');
      isLoading(false);
    }
  };

  const saveGeneralDetails = async () => {
    isLoading(true);
    const updateDetails = {
      patientBMI: patientData.patientDetails.patientBMI,
      patientMPI: patientData.patientDetails.patientMPI,
      partnerBMI: patientData.patientDetails.partnerBMI,
      partnerMPI: patientData.patientDetails.partnerMPI,
    };
    await updatePatientColumnApi(patientId, updateDetails);
    isLoading(false);
  };

  return (
    <ProtectedComponent
      requiredPermission={
        permissionsWithAssignedIds[permissionsList.ClinicalManager]
      }
    >
      <PageHeader
        // HeaderText="View Patients"
        Breadcrumb={[
          {
            name: 'Clinical Management',
            navigate: '/view-fet-patients',
          },
          {
            name: `Patient Clinical Info ${isReadOnly ? '(Read Only)' : ''}`,
            navigate: `/patient/${patientId}/clinical-management`,
          },
        ]}
      />
      <div
        className="flex"
        style={{
          alignItems: 'flex-start',
          position: 'sticky',
          zIndex: 1,
          background: '#ffff',
          padding: '5px',
        }}
      >
        <div className="container-fluid" style={{ flex: '1 0 0' }}>
          <button
            style={{ marginTop: 20 }}
            className="btn btn-primary"
            onClick={async () => {
              if (patientData.selectedPatientData?.patient?.id) {
                // dispatch(resetPatientData());
                const res = await getPatientDetailsApi(
                  patientData.selectedPatientData.patient.id,
                );
                dispatch(setSelectedPatientData(res.data));
              }
              navigate('/view-fet-patients');
            }}
          >
            Back
          </button>
        </div>
        <div
          style={{
            textAlign: 'center',
            marginTop: '20px',
            marginRight: '20px',
          }}
        >
          {activeTab !== 6 && !isReadOnly && (
            <>
              {patientData.currentCycle.cycleId && activeTab == 5 && (
                <button
                  className="btn btn-primary"
                  onClick={handleCycleCancel}
                  disabled={loading}
                >
                  End Cycle
                </button>
              )}
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                style={{ marginLeft: '10px' }}
                disabled={loading}
              >
                {activeTab == 5
                  ? patientData.currentCycle.cycleId
                    ? 'Save'
                    : 'Create New Cycle'
                  : 'Submit'}
              </button>
              <button
                onClick={() => navigate('/view-fet-patients')}
                style={{ marginLeft: '10px' }}
                className="btn btn-secondary"
                disabled={loading}
              >
                Cancel
              </button>
            </>
          )}
          {isReadOnly && (
            <div style={{ padding: '10px', backgroundColor: '#a9ecf8ff', border: '1px solid #a7d7ffff', borderRadius: '4px' }}>
              <span style={{ color: '#044d85ff', fontWeight: 'bold' }}>
                📖 Read-Only Mode - No changes can be saved
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="theme-blush component-wrapper">
        <div>
          <div className="card">
            <ul
              className="nav nav-tabs"
              role="tablist"
              style={{ background: '#ffff' }}
            >
              {activeTab === 1 && (
                <li
                  className={`nav-item mr-1 ${activeTab === 1 ? 'active' : ''}`}
                  // onClick={() => setActiveTab(1)}
                >
                  <Link
                    to="#"
                    className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                  >
                    Basic Details {isReadOnly && '(Read Only)'}
                  </Link>
                </li>
              )}
              {activeTab === 2 && (
                <li
                  className={`nav-item mr-1 ${activeTab === 2 ? 'active' : ''}`}
                  // onClick={() => setActiveTab(2)}
                >
                  <Link
                    to="#"
                    className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
                  >
                    Patient History {isReadOnly && '(Read Only)'}
                  </Link>
                </li>
              )}
              {activeTab === 3 && (
                <li
                  className={`nav-item mr-1 ${activeTab === 3 ? 'active' : ''}`}
                  // onClick={() => setActiveTab(3)}
                >
                  <Link
                    to="#"
                    className={`nav-link ${activeTab === 3 ? 'active' : ''}`}
                  >
                    Examination and Evaluation {isReadOnly && '(Read Only)'}
                  </Link>
                </li>
              )}
              {activeTab === 4 && (
                <>
                  <li
                    className={`nav-item mr-1 ${activeTab === 4 ? 'active' : ''}`}
                    // onClick={() => setActiveTab(4)}
                  >
                    <Link
                      to="#"
                      className={`nav-link ${activeTab === 4 ? 'active' : ''}`}
                    >
                      Treatment Plan {isReadOnly && '(Read Only)'}
                    </Link>
                  </li>
                </>
              )}
              {activeTab === 5 && (
                <li
                  className={`nav-item mr-1 ${activeTab === 5 ? 'active' : ''}`}
                  // onClick={() => setActiveTab(5)}
                >
                  <Link
                    to="#"
                    className={`nav-link ${activeTab === 5 ? 'active' : ''}`}
                  >
                    {isReadOnly ? 'View Cycle' : 'Create Cycle'}
                  </Link>
                </li>
              )}
            </ul>
            <div className="tab-content">
              {activeTab < 5 && (
                <>
                  {activeTab !== 5 && <GeneralDetails isReadOnly={isReadOnly} />}
                  {activeTab === 1 && (
                    <div className="tab-pane show active">
                      <PatientDetails isReadOnly={isReadOnly} />
                    </div>
                  )}
                  {activeTab === 2 && (
                    <div className="tab-pane show active">
                      <PatientHistory isReadOnly={isReadOnly} />
                    </div>
                  )}
                  {activeTab === 3 && (
                    <div className="tab-pane show active ">
                      <PatientExaminationAndEvaluation isReadOnly={isReadOnly} />
                    </div>
                  )}
                  {activeTab === 4 && (
                    <div className="tab-pane show active">
                      <TreatmentPlan isReadOnly={isReadOnly} />
                    </div>
                  )}
                </>
              )}

              {activeTab === 5 && (
                <div className="tab-pane show active">
                  {loadingCycleData ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <div>Loading cycle data...</div>
                    </div>
                  ) : (
                    <>
                  
                      <Fms 
                        patientData={selectedCycleData || currentCycle} 
                        isReadOnly={isReadOnly} 
                      />
                    </>
                  )}
                </div>
              )}

                {!isReadOnly && activeTab !== 6 && (
                <>
                  {patientData.currentCycle.cycleId && activeTab == 5 && (
                    <button
                      className="btn btn-primary"
                      onClick={handleCycleCancel}
                      disabled={loading}
                    >
                      End Cycle
                    </button>
                  )}
                  <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    style={{ marginLeft: '10px' }}
                    disabled={loading}
                  >
                    {activeTab == 5
                      ? patientData.currentCycle.cycleId
                        ? 'Save'
                        : 'Create New Cycle'
                      : 'Submit'}
                  </button>
                  <button
                    onClick={() => navigate('/view-fet-patients')}
                    style={{ marginLeft: '10px' }}
                    className="btn btn-secondary"
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </>
              )}

              {/* {activeTab === 6 && (
              <div className="tab-pane show active">
                <OtherCycles />
              </div>
            )} */}

     
            
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            {/* <button
            className="btn btn-primary"
            onClick={handleSubmit}
            // disabled={!validatePatientDetails()}
          >
            {activeTab == 5 ? 'Submit' : 'Save'}
          </button> */}
            {/* <button
            className="btn btn-secondary"
            onClick={prefillForm}
            style={{ marginLeft: '10px' }}
          >
            Prefill Form
          </button> */}
          </div>
        </div>
      </div>
    </ProtectedComponent>
  );
};

export default ClinicalProcess;
